module.exports = __webpack_public_path__ + "img/sv5.5477c3e0.svg";